<template>
    <Form :label-width="labelWidth"
        class="not-star"
        label-position="right">

        <Row :gutter="16">
            <Col v-for="(item,index) in form"
                :span="colSpan"
                :key="index">
            <template v-if="item.type === 'Input'">
                <FormItem :label="item.label + ':'"
                    :key="index">
                    <Input v-model="item.value"
                        size="small"></Input>
                </FormItem>
            </template>
            <template v-if="item.type === 'Select'">
                <FormItem :label="item.label + ':'"
                    :key="index">
                    <Select v-model="item.value"
                        :multiple="item.sql === 'in'"
                        @on-change="onSelectChange(item)"
                        size="small" :filterable="item.filterable">
                        <Option v-for="(optionItem) in item.options"
                            :key="optionItem.value"
                            :value="optionItem.value">{{ optionItem.key }}</Option>
                    </Select>
                </FormItem>
            </template>
            <template v-if="item.type === 'RadioGroup'">
                <FormItem :label="item.label + ':'"
                    :key="index">
                    <RadioGroup v-model="item.value"
                        size="small">
                        <Radio v-for="(optionItem,optionKey) in item.options"
                            :key="optionKey"
                            :label="optionItem.value">{{ optionItem.key }}
                        </Radio>
                    </RadioGroup>
                </FormItem>
            </template>
            <template v-if="item.type === 'CheckboxGroup'">
                <FormItem :label="item.label + ':'"
                    :key="index">
                    <CheckboxGroup v-model="item.value"
                        size="small">
                        <Checkbox v-for="(optionItem,optionKey) in item.options"
                            :key="optionKey"
                            :label="optionItem.value">{{ optionItem.key }}
                        </Checkbox>
                    </CheckboxGroup>
                </FormItem>
            </template>
            <template v-if="item.type === 'Checkbox'">
                <FormItem :label="item.label + ':'"
                    :key="index">
                    <Checkbox v-model="item.value"
                        size="small" />
                </FormItem>
            </template>
            <template v-if="item.type === 'Switch'">
                <FormItem :label="item.label + ':'"
                    :key="index">
                    <i-switch v-model="item.value"
                        size="small" />
                </FormItem>
            </template>
            <template v-if="item.type === 'Daterange'">
                <FormItem :label="item.label + ':'"
                    :key="index">
                    <DatePicker v-model="item.value"
                        format="yyyy年MM月dd日"
                        type="daterange"
                        placement="bottom-end"
                        style="width:100%; z-index:999;"
                        @on-change="formatDate(item.value)"
                        transfer
                        size="small" />
                </FormItem>
            </template>
            <template v-if="item.type === 'DateTimeRange'">
                <FormItem :label="item.label + ':'"
                    :key="index">
                    <DatePicker v-model="item.value"
                        format="yyyy-MM-dd HH:mm:ss"
                        type="datetimerange"
                        placement="bottom-end"
                        style="width:100%; z-index:999;"
                        @on-change="item.value=$event"
                        transfer
                        size="small" />
                </FormItem>
            </template>
            <template v-if="item.type === 'Date'">
                <FormItem :label="item.label + ':'"
                    :key="index">
                    <DatePicker v-model="item.value"
                        format="yyyy年MM月dd日"
                        type="date"
                        size="small"
                        transfer />
                </FormItem>
            </template>
            <template v-if="item.type === 'Cascader'">
                <FormItem :label="item.label + ':'"
                    :key="index">
                    <Cascader :data="item.cascaderData"
                        v-model="item.value"
                        size="small" />
                </FormItem>
            </template>
            </Col>

            <Col :span="searchBtnColSpan">
            <div style="float:left">
                <Button class="search-btn"
                    size="small"
                    type="primary"
                    shape="circle"
                    icon="ios-search"
                    @click="handleSearch">搜索
                </Button>
                <Button class="search-btn"
                    size="small"
                    icon="ios-refresh"
                    shape="circle"
                    style="margin-left: 5px;"
                    @click="resetSearch">重置</Button>
            </div>

            <slot name="otherButtons" />
            </Col>
        </Row>
    </Form>
</template>

<script>
import search from '@/libs/search';

export default {
    name: 'SearchCard',
    props: {
        form: {
            type: Array,
            required: true
        },
        labelWidth: {
            type: Number,
            default: 80
        },
        colSpan: {
            type: Number,
            default: 6
        },
        searchBtnColSpan: {
            type: Number,
            default: 6
        },
        tableLoadEvent: {
            type: Function,
            required: true
        },
        tableSearch: {
            type: Object,
            required: true
        }
    },
    data() {
        return {};
    },
    methods: {
        filterForm() {
            // 前端过滤
            let formEd = [];
            this.form.forEach(function (element) {
                switch (element.type) {
                    case 'Input':
                        if (element.value.replace(/(^s*)|(s*$)/g, '').length !== 0) {
                            formEd.push(element);
                        }
                        break;
                    case 'Checkbox':
                        formEd.push(element);
                        break;
                    case 'Switch':
                        formEd.push(element);
                        break;
                    case 'Daterange':
                        if (element.value.length > 0) {
                            let dateBegin = element.value[0];
                            let dateEnd = element.value[1];
                            if(dateBegin){
                                let aJson = new Date(dateBegin).toJSON();
                                if(aJson.length == 24 && aJson.indexOf('16:00:00') > -1){
                                    dateBegin = this.formatSingleDate(dateBegin);
                                    dateEnd = this.formatSingleDate(dateEnd);
                                    // dateEnd = this.formatSingleDateAddOnyDay(dateEnd);
                                }
                            }
                            if (dateBegin && dateEnd) {
                                formEd.push(Object.assign({}, element, {
                                    value: JSON.stringify([dateBegin, dateEnd])
                                }));
                            }
                        }
                        break;
                    case 'DateTimeRange':
                        if (element.value.length > 0) {
                            let dateBegin = element.value[0];
                            let dateEnd = element.value[1];
                            if (dateBegin && dateEnd) {
                                formEd.push(Object.assign({}, element, {
                                    value: JSON.stringify([dateBegin, dateEnd])
                                }));
                            }
                        }
                        break;
                    case 'Date':
                        if (element.value.replace(/(^s*)|(s*$)/g, '').length !== 0) {
                            formEd.push(element);
                        }
                        break;
                    case 'Select':
                        if (element.value != null && element.value !== undefined) {
                            if (Array.isArray(element.value)) {
                                if (element.value.length > 0) {
                                    formEd.push(Object.assign({}, element, {
                                        value: JSON.stringify(element.value)
                                    }));
                                }
                            }
                            else {
                                let arr = [];
                                arr.push(element.value);
                                formEd.push(Object.assign({}, element, {
                                    value: JSON.stringify(arr)
                                }));
                            }
                        }
                        break;
                    case 'RadioGroup':
                        if (element.value.replace(/(^s*)|(s*$)/g, '').length !== 0) {
                            formEd.push(element);
                        }
                        break;
                    case 'CheckboxGroup':
                        if (element.value.length > 0) {
                            formEd.push(element);
                        }
                        break;
                    case 'Cascader':
                        if (element.value.length >= 2) {
                            formEd.push(Object.assign({}, element, {
                                value: element.value[element.valueIndex]
                            }));
                        }
                        break;
                    default:
                        break;
                }
            }, this);

            return formEd;
        },
        handleSearch() {
            search.globalSetFilterWithSearchForm(this.tableSearch, this.filterForm());
            this.tableLoadEvent();

            this.$emit('handleSearch', this.filterForm());
        },
        resetSearch() {
            this.form.forEach(function (element) {
                switch (element.type) {
                    case 'Input':
                        element.value = '';
                        break;
                    case 'Checkbox':
                        element.value = false;
                        break;
                    case 'Switch':
                        element.value = true;
                        break;
                    case 'Daterange':
                        element.value = [];
                        break;
                    case 'DateTimeRange':
                        element.value = [];
                        break;
                    case 'Date':
                        element.value = '';
                        break;
                    case 'Select':
                        element.value = [];
                        break;
                    case 'RadioGroup':
                        element.value = '';
                        break;
                    case 'CheckboxGroup':
                        element.value = [];
                        break;
                    case 'Cascader':
                        element.value = [];
                        break;
                    default:
                        break;
                }
            }, this);

            this.$emit('handleSearch', []);
        },
        onSelectChange(item) {
            if (item.change) {
                item.change(item);
            }
        },
        formatDate(dateA) {
            let a = dateA[0];
            let aJson = new Date(a).toJSON();
            let aNewDate = new Date(+new Date(aJson) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');

            let b = dateA[1];
            let bJson = new Date(b).toJSON();
            let bNewDate = new Date(+new Date(bJson) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');

            dateA[0] = aNewDate;
            dateA[1] = bNewDate;
        },
        formatSingleDate(date){
            let aJson = new Date(date).toJSON();
            return new Date(+new Date(aJson) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
        },
        formatSingleDateAddOnyDay(date){
            let dateTime=new Date(date);
            dateTime.setDate(dateTime.getDate() + 1);
            let aJson =dateTime.toJSON();
            return new Date(+new Date(aJson) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
        }
    }
};

</script>

<style lang="less" scoped>
.not-star {
    border: 1px solid #dedede;
    padding: 5px 5px 5px 5px;

    .ivu-form-item-required .ivu-form-item-label:before {
        content: "";
    }

    // .ivu-form-item-label {
    //     font-weight: bolder;
    // }

    .ivu-form-item {
        margin-bottom: 6px;
    }
}

.search-card {
    padding: 10px;
    margin-bottom: 5px;
}

.search-btn {
    margin-top: 5px;
}
</style>
